export const agents = {
  title: "Agentes",
  subtitle: "Crie e gerencie agentes para automatizar suas tarefas",
  newAgent: "Novo Agente",
  noAgents: "Nenhum agente encontrado",
  edit: "Editar",
  delete: "Excluir",
  name: "Nome",
  description: "Descrição",
  systemPrompt: "Prompt do Sistema",
  greeting: "Mensagem de boas vindas",
  created: "Criado em {{date}}",
  profilePicture: "URL da imagem de perfil",
  temperature: "Temperatura",
  model: "Modelo",
  tools: "Ferramentas",
  create: "Criar Agente",
  table: {
    title: "Nome",
    description: "Descrição",
    tools: "Ferramentas",
    actions: "Ações",
    model: "Modelo",
  },
  actions: {
    edit: "Editar",
    delete: "Excluir",
    copyId: "Copiar ID",
    embed: "Embed",
    embedCodeCopied:
      "Código de incorporação copiado para a área de transferência",
    embedCodeCopiedDescription: "Você pode colar em qualquer lugar",
  },
  character: "Personagem",
  update: "Atualizar",
  usageMode: "Modo de Uso",
  anonymous: "Anônimo",
  authenticated: "Autenticado",
};
